import { Provider } from "react-redux"
import store from "./src/redux/store"
import { PersistGate } from "redux-persist/integration/react"
import { persistStore } from "redux-persist"
import RecaptchaContext from "./src/components/PageStateContext"
import TrackingScripts from "./src/components/Helmet/TrackingScript"
// import UseLazyGoogleAnalytics from "./src/hooks/useLazyGoogleAnalytics"
const React = require("react")
export const wrapPageElement = ({ element, props, location }) => {
  let persistor = persistStore(store)

  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <RecaptchaContext captchaSiteKey={props?.pageContext?.captchaSiteKey}>
          <TrackingScripts scripts={props?.pageContext?.headerScript} />
          {/* <UseLazyGoogleAnalytics
            measurementId={props?.pageContext?.googleAnalyticsCode}
          /> */}
          {element}
        </RecaptchaContext>
      </PersistGate>
    </Provider>
  )
}

// export const onRouteUpdate = ({ location }) => {
//   if (typeof window === "undefined") return

//   const tryTrack = () => {
//     if (window.gtag) {
//       const title = document.title
//       console.log("Tracking page view:", location.pathname)

//       window.gtag("event", "page_view", {
//         page_title: title,
//         page_path: location.pathname + location.search + location.hash,
//       })
//     } else {
//       console.warn("gtag not ready, retrying...")
//       setTimeout(tryTrack, 250)
//     }
//   }

//   tryTrack()
// }
